import { render, staticRenderFns } from "./support-log.vue?vue&type=template&id=97705cfc&scoped=true&"
import script from "./support-log.vue?vue&type=script&lang=js&"
export * from "./support-log.vue?vue&type=script&lang=js&"
import style0 from "./support-log.vue?vue&type=style&index=0&id=97705cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97705cfc",
  null
  
)

export default component.exports